import { clearCachedValues } from "./cache";

export const CACHE_KEYS = {
  dashboard: "dashboard-overview",
  coordinatorDashboard: "coordinator-dashboard-overview",
  employeeDashboard: "employee-dashboard",
  crmDashboard: "crm-dashboard",
  notificationsUnread: "notifications-unread-count",
  notificationsList: "notifications-list",
  purchaseOrders: "purchase-orders",
  purchaseOrder: (id) => `po:${id}`,
  poCoordinators: "po-coordinators",
  poFinanceApprovers: "po-finance-approvers",
  users: "users",
  departments: "departments",
  expenses: (scope) => `expenses:${scope}`,
  tasks: (role) => `tasks:${role}`,
  taskSummary: (role) => `task-summary:${role}`,
  taskAssignees: (role) => `task-assignees:${role}`,
};

export function invalidateDashboardCaches() {
  clearCachedValues([
    CACHE_KEYS.dashboard,
    CACHE_KEYS.coordinatorDashboard,
    CACHE_KEYS.employeeDashboard,
    CACHE_KEYS.crmDashboard,
  ]);
}

export function invalidateExpenseCaches() {
  clearCachedValues([
    CACHE_KEYS.expenses("all"),
    CACHE_KEYS.expenses("my"),
  ]);
}

export function invalidateNotificationCaches() {
  clearCachedValues([
    CACHE_KEYS.notificationsUnread,
    CACHE_KEYS.notificationsList,
  ]);
}

export function invalidatePurchaseOrderCaches(id) {
  clearCachedValues([
    CACHE_KEYS.purchaseOrders,
    id ? CACHE_KEYS.purchaseOrder(id) : null,
  ]);
}

export function invalidateReferenceCaches() {
  clearCachedValues([
    CACHE_KEYS.users,
    CACHE_KEYS.departments,
  ]);
}

export function invalidateTaskCaches(role) {
  clearCachedValues([
    CACHE_KEYS.tasks(role),
    CACHE_KEYS.taskSummary(role),
    CACHE_KEYS.taskAssignees(role),
  ]);
}
